import { css } from '@emotion/core';
import { fontWeights, typography } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const section = css({
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  marginBottom: 32,
  paddingBottom: 32,

  '&:last-child': {
    borderBottom: 0,
    marginBottom: 0,
    paddingBottom: 0,
  },
});

export const title = css(typography.effra22);

export const titleFeatures = css(typography.effra22, {
  maxWidth: 404,
});

export const features = css({
  marginTop: 24,
  maxWidth: 404,
});

export const feature = css(typography.effra16, {
  marginBottom: 16,
  paddingLeft: 35,
  position: 'relative',

  // Hidden by default, displayed when toggled
  ':nth-of-type(n + 5)': {
    display: 'none',
  },

  '&:last-child': {
    marginBottom: 0,
  },
});

export const featureToggle = css(typography.effra12Link, {
  backgroundColor: colorsPalette.transparent,
  border: 0,
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  color: colorsPalette.grey60,
  cursor: 'pointer',
  fontWeight: fontWeights.medium,
  lineHeight: '1.67',
  marginTop: 16,
  padding: 0,
  position: 'relative',

  '.icon-chevron': {
    position: 'absolute',
    right: -18,
    top: 2,
  },
});

export const featureToggleClose = css({
  marginTop: 32,
  '.icon-chevron': {
    transform: 'rotate(180deg)',
  },
});

export const featureToggleIcon = css({
  marginTop: 29,
});

export const featuresOpen = css(typography.effra16, {
  'li:nth-of-type(n + 5)': {
    display: 'block',
  },
});

export const featureIcon = css({
  display: 'inline-block',
  height: 18,
  left: 0,
  position: 'absolute',
  top: 5,
  width: 18,

  img: {
    width: '100%',
    height: '100%',
  },
});

export const services = css({
  marginTop: 8,
});

export const service = css({
  alignItems: 'flex-end',
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 0',
});

export const description = css(typography.effra16, {
  width: '60%',
});

export const cost = css(typography.effra16, {
  fontWeight: fontWeights.medium,
});
